/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "complaints-widget" };
const _hoisted_2 = {
    key: 0,
    class: "complaints-widget-error"
};
const _hoisted_3 = {
    key: 1,
    class: "complaints-widget-check"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "complaints-widget-check__phone" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
import { api } from '@/api/api';
import { countryMasksExtended } from '@/constants/common';
import { CountryCodes } from '@/types/types';
import { formatPhoneNumber } from '@/utils/common';
import ComplaintsWidgetMain from './components/ComplaintsWidgetMain.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ComplaintsWidget',
    props: {
        country: {}
    },
    setup(__props) {
        /* eslint-disable @intlify/vue-i18n/no-missing-keys */
        const props = __props;
        const { t } = useI18n();
        const errorText = ref('');
        const phone = ref('');
        const isSuccess = ref(false);
        const isMainShow = ref(true);
        const isCheckShow = ref(false);
        const isResultShow = ref(false);
        const errorTextCountry = ref('');
        const isValidCountry = computed(() => {
            if (!props.country)
                return false;
            return Object.values(CountryCodes).includes(props.country);
        });
        if (!isValidCountry.value) {
            errorTextCountry.value = t('invalid_country_code');
            console.error(errorTextCountry.value);
        }
        const country = props.country;
        const ERROR_KEYS = {
            CALL_DATA_NOT_FOUND: t('call_details_not_found_please_call_again'),
            FORBIDDEN_PHONE_COUNTRY: t('the_phone_number_you_entered_is_not_in_the_country'),
            PHONE_MUST_BE_MOBILE: t('login_is_only_possible_with_a_mobile_number'),
            CALL_NOT_EXIST: t('we_did_not_find_any_calls_to_your_number'),
            UNKNOWN_ERROR: t('please_try_again_or_contact_support'),
        };
        const formatedPhone = computed(() => {
            return phone.value ? formatPhoneNumber(phone.value, countryMasksExtended[country]) : '';
        });
        const onSuccess = (payload) => {
            phone.value = payload;
            isMainShow.value = false;
            isCheckShow.value = true;
            addCallBlocking();
        };
        const addCallBlocking = async () => {
            try {
                const sessionId = localStorage.getItem('sessionid') || '';
                if (!sessionId) {
                    errorText.value = t('please_try_again_or_contact_support');
                    return;
                }
                await api.complaints.callBlocking(country, sessionId);
                localStorage.removeItem('sessionid');
                isSuccess.value = true;
            }
            catch (e) {
                isSuccess.value = false;
                const axiosError = e;
                const errorStatus = axiosError.response?.data?.data?.error_status;
                if (errorStatus && ERROR_KEYS[errorStatus]) {
                    errorText.value = ERROR_KEYS[errorStatus];
                }
                else {
                    errorText.value = t('error');
                }
                console.error('Error:', axiosError.response?.data);
            }
            finally {
                isCheckShow.value = false;
                isResultShow.value = true;
            }
        };
        const onTryAgain = () => {
            isMainShow.value = true;
            isCheckShow.value = false;
            isResultShow.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createCommentVNode(" eslint-disable @intlify/vue-i18n/no-missing-keys "),
                _createElementVNode("div", _hoisted_1, [
                    (_unref(errorTextCountry))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(errorTextCountry)), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_unref(isMainShow))
                                ? (_openBlock(), _createBlock(ComplaintsWidgetMain, {
                                    key: 0,
                                    country: _unref(country),
                                    onSuccess: onSuccess
                                }, null, 8 /* PROPS */, ["country"]))
                                : _createCommentVNode("v-if", true),
                            (_unref(isCheckShow))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "complaints-widget-spinner" }, [
                                        _createElementVNode("svg", {
                                            width: "60",
                                            height: "60",
                                            viewBox: "0 0 60 60",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg"
                                        }, [
                                            _createElementVNode("circle", {
                                                opacity: "0.2",
                                                cx: "29.8135",
                                                cy: "30.0729",
                                                r: "24.4536",
                                                stroke: "#FF7545",
                                                "stroke-width": "10.5745"
                                            }),
                                            _createElementVNode("path", {
                                                d: "M28.2604 5.60742C39.4132 5.60742 54.2836 11.8034 54.2836 31.6307",
                                                stroke: "#FF7545",
                                                "stroke-width": "10.5745",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            })
                                        ])
                                    ], -1 /* CACHED */)),
                                    _createElementVNode("div", {
                                        class: "complaints-widget-check__text",
                                        innerHTML: _ctx.$t('check_who_called')
                                    }, null, 8 /* PROPS */, _hoisted_4),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatedPhone)), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true),
                            (_unref(isResultShow))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["complaints-widget-result", { error: !_unref(isSuccess) }])
                                }, [
                                    (_unref(isSuccess))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[1] || (_cache[1] = _createElementVNode("svg", {
                                                width: "60",
                                                height: "60",
                                                viewBox: "0 0 60 60",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg"
                                            }, [
                                                _createElementVNode("circle", {
                                                    cx: "30",
                                                    cy: "30",
                                                    r: "30",
                                                    fill: "#63B570"
                                                }),
                                                _createElementVNode("path", {
                                                    d: "M28.3423 41.3598C26.7555 42.8801 24.1807 42.8801 22.5947 41.3598L13.6896 32.8278C12.1028 31.3083 12.1028 28.8414 13.6896 27.3218C15.2756 25.8015 17.8504 25.8015 19.4372 27.3218L24.7429 32.4045C25.1434 32.7875 25.7936 32.7875 26.1949 32.4045L40.5611 18.6402C42.1471 17.1199 44.7218 17.1199 46.3086 18.6402C47.0706 19.3703 47.4987 20.3609 47.4987 21.3932C47.4987 22.4256 47.0706 23.4161 46.3086 24.1462L28.3423 41.3598Z",
                                                    fill: "white"
                                                })
                                            ], -1 /* CACHED */)),
                                            _createElementVNode("div", {
                                                class: "complaints-widget-result-text",
                                                innerHTML: _ctx.$t('disabled_calls')
                                            }, null, 8 /* PROPS */, _hoisted_6)
                                        ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                                width: "60",
                                                height: "60",
                                                viewBox: "0 0 60 60",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg"
                                            }, [
                                                _createElementVNode("circle", {
                                                    cx: "30",
                                                    cy: "30",
                                                    r: "30",
                                                    fill: "#D31A1A"
                                                }),
                                                _createElementVNode("path", {
                                                    d: "M25.1251 40.7701C25.4751 40.0701 26.0001 39.5976 26.7001 39.3526C27.4351 39.1076 28.5551 38.9851 30.0601 38.9851C31.6001 38.9851 32.7026 39.3176 33.3676 39.9826C34.0676 40.6476 34.4176 41.6976 34.4176 43.1326V43.9726C34.4176 44.8126 34.3826 45.4426 34.3126 45.8626C34.2776 46.2477 34.1201 46.7202 33.8401 47.2801C33.2801 48.2952 31.9326 48.8026 29.7976 48.8026C27.6976 48.8026 26.2976 48.47 25.5976 47.8051C24.9326 47.105 24.6001 45.7752 24.6001 43.8151C24.6001 42.4501 24.7751 41.4351 25.1251 40.7701ZM32.1601 34.6276C31.4951 34.8026 30.6026 34.8901 29.4826 34.8901C28.3626 34.8901 27.4701 34.8026 26.8051 34.6276C26.1401 34.4526 25.6676 34.1376 25.3876 33.6826C25.1426 33.2276 24.9851 32.8251 24.9151 32.4751C24.8801 32.1251 24.8626 31.5826 24.8626 30.8476V14.2051C24.8626 13.4701 24.8801 12.9276 24.9151 12.5776C24.9851 12.1926 25.1601 11.7726 25.4401 11.3176C25.7201 10.8626 26.1926 10.5476 26.8576 10.3726C27.5226 10.1626 28.4151 10.0576 29.5351 10.0576C30.6551 10.0576 31.5476 10.1626 32.2126 10.3726C32.8776 10.5476 33.3326 10.8801 33.5776 11.3701C33.8576 11.8251 34.0151 12.2451 34.0501 12.6301C34.1201 12.9801 34.1551 13.5226 34.1551 14.2576V30.9001C34.1551 31.6351 34.1201 32.1776 34.0501 32.5276C34.0151 32.8776 33.8576 33.2801 33.5776 33.7351C33.2976 34.1551 32.8251 34.4526 32.1601 34.6276Z",
                                                    fill: "white"
                                                })
                                            ], -1 /* CACHED */)),
                                            _createElementVNode("div", {
                                                class: "complaints-widget-result-text",
                                                innerHTML: _unref(errorText)
                                            }, null, 8 /* PROPS */, _hoisted_7),
                                            _createElementVNode("button", { onClick: onTryAgain }, _toDisplayString(_ctx.$t('try_another_number')), 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
